import Icon from '../components/Icon.vue'

Icon.register({
  transgender: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M372 0c6.6 0 12 5.4 12 12v79c0 10.7-12.9 16.1-20.5 8.5l-16.9-16.9-80.7 80.7c14 22.2 22.1 48.5 22.1 76.7 0 68.5-47.9 125.8-112 140.4v27.6h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v28c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-28h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-27.6c-64.1-14.5-112-71.9-112-140.4 0-79.5 64.5-144 144-144 28.2 0 54.5 8.1 76.7 22.1l80.7-80.7-16.9-16.9c-7.5-7.6-2.2-20.5 8.5-20.5h79zM144 320c44.1 0 80-35.9 80-80s-35.9-80-80-80-80 35.9-80 80 35.9 80 80 80z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/transgender.js
// module id = 2028
// module chunks = 0